module.exports = __webpack_public_path__ + "static/media/jivetel-logo.3eab3098.png";